import { SVGAttributes } from "react";

export const BlockquoteIcon = (
  props: SVGAttributes<SVGElement> & { size: "small" | "regular" }
) => {
  if (props.size === "small") {
    return (
      <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 14h2c1.102 0 2-.898 2-2v-2c0-1.102-.898-2-2-2H2v4c0 1.102.898 2 2 2zm0-2v-2h2v2H4z"
          fill="currentColor"
        />
        <path
          d="M4 9a1 1 0 01-2 0V7c0-.555.166-1.302.668-2.055C3.484 3.72 4.925 3 7 3a1 1 0 010 2c-1.425 0-2.234.404-2.668 1.055C4.084 6.427 4 6.805 4 7v2z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 14h2c1.102 0 2-.898 2-2v-2c0-1.102-.898-2-2-2H9v4c0 1.102.898 2 2 2zm0-2v-2h2v2h-2z"
          fill="currentColor"
        />
        <path
          d="M11 9a1 1 0 11-2 0V7c0-.555.166-1.302.668-2.055C10.485 3.72 11.926 3 14 3a1 1 0 110 2c-1.425 0-2.235.404-2.668 1.055-.248.372-.332.75-.332.945v2z"
          fill="currentColor"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 17.867v-6.934C3 6.411 5.466 4 10 4c.552 0 1 .478 1 1.067s-.448 1.066-1 1.066c-3.466 0-5 1.5-5 4.8v.534h4c1.105 0 2 .955 2 2.133v4.267C11 19.045 10.105 20 9 20H5c-1.105 0-2-.955-2-2.133zm10-6.934v6.934c0 1.178.896 2.133 2 2.133h4c1.105 0 2-.955 2-2.133V13.6c0-1.178-.895-2.133-2-2.133h-4v-.534c0-3.3 1.534-4.8 5-4.8.552 0 1-.477 1-1.066C21 4.477 20.552 4 20 4c-4.534 0-7 2.411-7 6.933zm-8 6.934V13.6h4v4.267H5zm10 0V13.6h4v4.267h-4z"
          fill="currentColor"
        />
      </svg>
    );
  }
};
BlockquoteIcon.displayName = "BlockquoteIcon";
